export function scrollTo(ele: Element, options?: ScrollToOptions) {
    ele.scrollTo?.(options)
}
